class RoutineTabs {
  constructor() {
    this.tabLinks = [];
    this.tabContents = [];
    this.currentTabIndex = 0;
    
    this.init();
  }

  init() {
    this.initRoutineTabs();
  }

  initRoutineTabs() {
    this.tabLinks = document.querySelectorAll('.routine-tab-link');
    this.tabContents = document.querySelectorAll('.routine-tab-content');
    
    if (this.tabLinks.length === 0 || this.tabContents.length === 0) return;
    
    this.showTab(0);
    
    this.tabLinks.forEach((link, index) => {
      link.addEventListener('click', () => this.showTab(index));

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.showTab(index);
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const direction = e.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + this.tabLinks.length) % this.tabLinks.length;
          this.showTab(nextIndex);
          this.tabLinks[nextIndex].focus();
        }
      });
    });
  }

  showTab(index) {

    this.tabLinks.forEach((link) => {
      link.classList.remove('current');
      link.setAttribute('aria-selected', 'false');
      link.setAttribute('tabindex', '-1');
    });
    this.tabContents.forEach(content => content.classList.remove('current'));

    if (this.tabLinks[index]) {
      this.tabLinks[index].classList.add('current');
      this.tabLinks[index].setAttribute('aria-selected', 'true');
      this.tabLinks[index].setAttribute('tabindex', '0');
    }
    if (this.tabContents[index]) this.tabContents[index].classList.add('current');

    this.currentTabIndex = index;
    
    this.scrollTabIntoView(index);
  }

  scrollTabIntoView(index) {
    const activeTab = this.tabLinks[index];
    const tabsContainer = document.querySelector('[data-routine-tabs-nav]');
    
    if (!activeTab || !tabsContainer) return;
    
    const containerRect = tabsContainer.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    
    const scrollLeft = tabsContainer.scrollLeft;
    const tabLeft = tabRect.left - containerRect.left;
    const tabWidth = tabRect.width;
    const containerWidth = containerRect.width;
    
    const targetScrollLeft = scrollLeft + tabLeft - (containerWidth / 2) + (tabWidth / 2);
    
    tabsContainer.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }

  getCurrentTabIndex() {
    return this.currentTabIndex;
  }

  getTabCount() {
    return this.tabLinks.length;
  }

  static showTab(index) {
    if (window.routineTabsInstance) {
      window.routineTabsInstance.showTab(index);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.routineTabsInstance = new RoutineTabs();
});

window.RoutineTabs = RoutineTabs;
